import { IBank } from '../../types/developer/banks';
import { IApplicationState } from '../../types/redux';
import { getDeveloper } from './getDeveloper';

const emptyBanks = Array.of<IBank>();

export function getBanks(state: IApplicationState) {
  const developer = getDeveloper(state);

  if (state.fsk?.mortgageBanks) {
    return state.fsk.mortgageBanks.map((bank, index) => ({
      downPayment: bank.firstPaymentFrom,
      id: index,
      interestRate: bank.rateFrom,
      logo: bank.icon,
      name: bank.bankName,
    }));
  }

  if (!developer) {
    return emptyBanks;
  }

  return developer.banks;
}
